import {useEffect, useState} from 'react'
import {MenuComponent} from '../../../../../../../_metronic/assets/ts/components'
import {initialQueryState, KTSVG} from '../../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import { getPlan} from '../../../../users/user-list/core/_requests'
import DatePicker from 'react-datepicker'

const EmployeeListFilter = () => {
  const {updateState} = useQueryRequest()
  const {isLoading} = useQueryResponse()
  const [plan, setplan] = useState<any>([])
  const [planId, setplanId] = useState<string | undefined>()
  const [planStatusId, setPlanStatusId] = useState<string | undefined>()
  const [dateRange, setDateRange] = useState([null, null])
  const [expiredDateRange, setExpiredDateRange] = useState([null, null])
  const [startDate, endDate] = dateRange
  const [expiedStartDate, expiredEndDate] = expiredDateRange

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const resetData = () => {
    updateState({filter: undefined, ...initialQueryState});
    setplanId('');
    setPlanStatusId('');
    setDateRange([null, null]);
    setExpiredDateRange([null, null]);
  }

  useEffect(() => {
    getPlan().then((res: any) => {
      setplan(res.data.Data)
    })

    return ()=>{
      setplan([]);
    }
  }, [])

  const filterData = () => {
    let createdDate = (document.getElementById('Daterange') as HTMLInputElement).value
    let expiredDate = (document.getElementById('DaterangeExpired') as HTMLInputElement).value
    updateState({
      filter: { planId , planStatusId , createdDate , expiredDate },
      ...initialQueryState,
    })
  }

  return (
    <>
      {/* begin::Filter Button */}
      <button
        disabled={isLoading}
        type='button'
        className='btn btn-light-primary me-3'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
        Filter
      </button>
      {/* end::Filter Button */}
      {/* begin::SubMenu */}
      <div className='menu menu-sub menu-sub-dropdown w-300px w-md-325px' data-kt-menu='true'style={{ maxHeight: 'calc(400px - 80px)', overflowY: 'auto' }}>
        {/* begin::Header */}
        <div className='px-7 py-5'>
          <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
        </div>
        {/* end::Header */}

        {/* begin::Separator */}
        <div className='separator border-gray-200'></div>
        {/* end::Separator */}

        {/* begin::Content */}
        <div className='px-7 py-5' data-kt-user-table-filter='form'>
          {/* begin::Input group */}
          <div className='mb-10'>
            <label className='form-label fs-6 fw-bold'>Plan :</label>
            <select
              className='form-select form-select-solid fw-bolder'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              data-kt-user-table-filter='role'
              data-hide-search='true'
              onChange={(e) => setplanId(e.target.value)}
              value={planId}
            >
              <option value=''>All</option>
              {plan?.map((item: any, i: any) => {
                return (
                  <option key={i} value={item.id}>
                    {item.name}
                  </option>
                )
              })}
            </select>
          </div>
          {/* end::Input group */}

          {/* begin::Input group */}
          <div className='mb-10'>
            <label className='form-label fs-6 fw-bold'>Status :</label>
            <select
              className='form-select form-select-solid fw-bolder'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              data-kt-user-table-filter='two-step'
              data-hide-search='true'
              onChange={(e) => setPlanStatusId(e.target.value)}
              value={planStatusId}
            >
              <option value=''>All</option>
              <option value={0}>Active</option>
              <option value={1}>Expired</option>
     
            </select>
          </div>
          {/* end::Input group */}

                 {/* begin::datefilter */}
                 <div className='mb-10'>
              <label className=' col-form-label fw-bold fs-6'>Subscription Date:</label>
              <div onClick={(e) => e.stopPropagation()}>
              <DatePicker
              className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                id='Daterange'
                selectsRange={true}
                startDate={startDate}
                endDate={endDate}
                onChange={(event: any) => {
                  setDateRange(event)
                }}
                isClearable={true}
                dateFormat='dd/MM/yyyy'
              />
              </div>
            </div>
             {/* begin::datefilter */}

                 {/* begin::datefilter */}
                 <div className='mb-10'>
              <label className=' col-form-label fw-bold fs-6'>Expied Date :</label>
              <div onClick={(e) => e.stopPropagation()}>
              <DatePicker
              className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                id='DaterangeExpired'
                selectsRange={true}
                startDate={expiedStartDate}
                endDate={expiredEndDate}
                onChange={(event: any) => {
                  setExpiredDateRange(event)
                }}
                isClearable={true}
                dateFormat='dd/MM/yyyy'
              />
              </div>
            </div>
             {/* begin::datefilter */}

          {/* begin::Actions */}
          <div className='d-flex justify-content-end'>
            <button
              type='button'
              disabled={isLoading}
              onClick={resetData}
              className='btn btn-light btn-active-light-primary fw-bold me-2 px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='reset'
            >
              Reset
            </button>
            <button
              disabled={isLoading}
              type='button'
              onClick={filterData}
              className='btn btn-primary fw-bold px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='filter'
            >
              Apply
            </button>
          </div>
          {/* end::Actions */}
        </div>
        {/* end::Content */}
      </div>
      {/* end::SubMenu */}
    </>
  )
}

export {EmployeeListFilter}
